import { useAppState } from 'src/state';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs'

export function AgencyOperationsAdminVenueBreadCrumb({}:BreadcrumbComponentProps): React.ReactElement {
    const { currentItem } = useAppState().tenants
    if (!currentItem) return <span>Venue</span>;
    return (
        <span>{`${currentItem.name}`}</span>
    );
}